import styled from "styled-components"
import { RichContentView } from "@ui"

export const ContactUsElementRichContent = styled(RichContentView)<{
  color?: string
}>`
  color: ${(props) => props.color};
  max-width: 750px;

  & blockquote {
    &:before {
      background: ${(props) => props.color};
    }
  }

  p {
    margin-bottom: 8px;
  }

  & ul {
    list-style: outside;
    margin-left: 16px;

    li {
      padding-left: 8px;
    }
  }

  ${(props) => props.theme.ViewPorts.mobile} {
    max-width: 100%;
  }

  a {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.FontFamily.sansSerifBold};
    text-decoration: none;
    font-size: 14px;
    line-height: 18px;

    &:hover {
      color: ${(props) => props.theme.Colors.black};
      opacity: 0.7;
    }
  }
`
